import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Container from '../../components/Container';
import {Grid, ListItem, Box} from '@material-ui/core'
import Typography from '../../components/CustomTypo'
import {BackOnPrimaryIcon} from '../../components/icons'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import InfiniteScroll from 'react-infinite-scroll-component';
const styles = theme => ({
    container:{
        padding: theme.spacing(6),
    },
    item:{
        marginTop:theme.spacing(4),
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
    },

});
function AllotmentDetailView(props){
    const { classes, t, wallet_info, currency,onCloseAllotment,showLoading, handleLoadMore, hasMore, showLoadMore } = props;
    //console.log("wallet_info:", this.props.wallet_info);
    const allotments = Array.from(wallet_info)
    return (
        <DrawerCustom 
            open={props.open} 
            onClose = {onCloseAllotment} 
            title = {t('allotment_title')}
            children={        
                <Grid item>
                    <Grid xs={12} item >
                        <Typography variant='body1' color='onPrimary' >{t('allotment_desc')}</Typography>
                    </Grid>
                    {showLoading?<Grid xs ={12} item container justify='center'><CustomizedCircularProgress color="primary"/></Grid>:null}
                    <Grid xs={12} item>
                    <InfiniteScroll
                        dataLength={allotments.length} //This is important field to render the next data
                        next={handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                        <Grid xs={12} item container className={classes.margin}>
                            {allotments.map((item,index)=>item.amount&&item.amount>0?
                                <AllotmentItem key={index} item = {item} classes={classes} currency={currency}/>:null
                            )}
                        </Grid>
                    </InfiniteScroll>
                </Grid>
           </Grid>}/>
    );
}
function AllotmentItem(props) {
    const { item,currency } = props;
   const { classes, t } = props;
    return (
            <Grid xs = {12} item container className={classes.item}>
                <Grid item container xs={12} >
                    <Typography variant='h3'>{currency}{item.amount ? item.amount : "0.00"}</Typography>
                </Grid>
                <Grid item container xs={12} >
                    <Typography mg_top_md >{item.conditionText}</Typography>
                </Grid>
            </Grid>
    )
}
export default withStyles(styles)(withTranslation()(AllotmentDetailView));